import React, { useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FieldSet } from "../../elements";
import TransferAppropriationModal from "./TransferAppropriationModal";

const userLabel = (user) => (
  user ? user.display_name || user.last_name || user.username : ""
);

const AppropriationHistory = ({
  appropriations,
  canTransfer,
  onTransfer,
  loading,
  entityLabel,
  fetchUsersApi,
}) => {
  const [appropriationToTransfer, setAppropriationToTransfer] = useState(null);

  const handleConfirmTransfer = (user) => {
    onTransfer(appropriationToTransfer.id, user.id);
    setAppropriationToTransfer(null);
  };

  const renderStatus = (appropriation) => {
    if (!appropriation.end_date) {
      return <span className="badge badge-primary">Ativa</span>;
    }

    if (appropriation.transferred_to_user) {
      return <span className="badge badge-warning">Transferida</span>;
    }

    return <span className="badge badge-secondary">Finalizada</span>;
  };

  return (
    <>
      <FieldSet title="Histórico de Apropriações" />
      <div className="table-responsive">
        <table className="table table-striped appropriation-history">
          <thead>
            <tr>
              <th>Usuário</th>
              <th>Data de Início</th>
              <th>Data de Término</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {appropriations.map((appropriation) => (
              <tr key={appropriation.id}>
                <td>{userLabel(appropriation.user)}</td>
                <td>{appropriation.start_date}</td>
                <td>
                  {appropriation.end_date || (
                    <span className="badge badge-success">Em andamento</span>
                  )}
                </td>
                <td>{renderStatus(appropriation)}</td>
                <td>
                  {!appropriation.end_date && canTransfer && (
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      title="Transferir apropriação"
                      aria-label="Transferir apropriação"
                      disabled={loading}
                      onClick={() => setAppropriationToTransfer(appropriation)}
                    >
                      <FontAwesomeIcon icon="ellipsis-vertical" size="lg" />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <TransferAppropriationModal
        visible={!!appropriationToTransfer}
        appropriationOwner={
          appropriationToTransfer ? appropriationToTransfer.user : null
        }
        loading={loading}
        onCancel={() => setAppropriationToTransfer(null)}
        onConfirm={handleConfirmTransfer}
        entityLabel={entityLabel}
        fetchUsersApi={fetchUsersApi}
      />
    </>
  );
};

const userShape = PropTypes.shape({
  id: PropTypes.number,
  username: PropTypes.string,
  last_name: PropTypes.string,
});

AppropriationHistory.propTypes = {
  appropriations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      user: userShape,
      start_date: PropTypes.string,
      end_date: PropTypes.string,
      transferred_from_user: userShape,
      transferred_to_user: userShape,
    })
  ),
  canTransfer: PropTypes.bool,
  onTransfer: PropTypes.func,
  loading: PropTypes.bool,
  entityLabel: PropTypes.string,
  fetchUsersApi: PropTypes.func,
};

AppropriationHistory.defaultProps = {
  appropriations: [],
  canTransfer: false,
  onTransfer: () => {},
  loading: false,
  entityLabel: "matrícula",
  fetchUsersApi: undefined,
};

export default AppropriationHistory;
